module.exports = __webpack_public_path__ + "static/media/game-results-active-icon.602370f3.svg";